import { useState, useRef, useEffect } from 'react'

import { useLazyQuery } from 'components/graphql'

export const useSplittedQuery = ({ query, splittedPeriodRef }) => {
	const queryCounter = useRef(0)
	const stitchedData = useRef([])
	const [useStitchedData, setUseStitchedData] = useState(false)
	const [stitchedDataFetched, setStitchedDataFetched] = useState(false)
	const [runQuery, { data, queryField, loading, called, variables = {} }] = useLazyQuery(query, { onCompleted: () => {
		if(splittedPeriodRef?.current?.length) {
			if(queryCounter.current < splittedPeriodRef?.current?.length) {
				runQuery({ variables: {
					...variables,
					params: {
						...variables?.params && { ...variables?.params },
						...splittedPeriodRef?.current[queryCounter.current] || {}
					}
				} })
				queryCounter.current += 1
			} else {
				setStitchedDataFetched(true)
				queryCounter.current = 0
				splittedPeriodRef.current = []
			}
			stitchedData.current = [...stitchedData.current, ...data?.[queryField] ?? []]
		}
	} })

	const fetch = queryParams => {
		if(splittedPeriodRef?.current?.length) {
			setUseStitchedData(true)
			setStitchedDataFetched(false)
			stitchedData.current = []
		} else {
			setUseStitchedData(false)
		}
		runQuery(queryParams)
	}

	const isLoading = useStitchedData ? !stitchedDataFetched : !data?.[queryField] && loading

	return [fetch, {
		data: data?.[queryField],
		stitchedData: stitchedData.current,
		useStitchedData,
		fetch,
		loading: isLoading,
		called
	}]
}

export const useStatisticsData = ({ getQuery, initQuery }) => {
	const [callGetStatisticsData, getRes] = useLazyQuery(getQuery, {
		pollInterval: 2000,
		fetchPolicy: 'network-only'
	})
	const [callInit, initRes] = useLazyQuery(initQuery, {
		onCompleted: res => {
			const requestId = Object.entries(res?.cashAssist || {}).filter(([key, value]) => key !== '__typename')[0][1]
			callGetStatisticsData({
				variables: {
					requestId
				}
			})
		}
	})

	const status = getRes?.data?.getStatisticsData?.status
	const data = getRes?.data?.getStatisticsData?.data || []
	const loading = initRes.loading || getRes.loading || getRes?.data?.getStatisticsData?.status === 'LOADING'
	const called = initRes.called || getRes.called

	useEffect(() => {
		if(status === 'READY' || status === 'ERROR') {
			getRes.stopPolling()
		}
	}, [getRes.data])

	return {
		getStatistics: callInit,
		status,
		data,
		loading,
		called
	}
}

export const getMaxTableHeight = (tableId, tableHeight = 400) => {
	const el = document.getElementById(tableId)
	const offset = el?.getBoundingClientRect()?.top ?? 0
	const height = window.innerHeight - offset - 100 // 100 - distance to the bottom of the screen
	return height > tableHeight ? height : tableHeight
}
